import React, {useEffect, useRef, useState} from 'react';
import Posts from '@/components/posts';
import PostsService from "@/services/posts-service";
import {useParams} from "react-router-dom";
import { setCanonical } from '@/app/general';

type Props = {
  post_type: "beat" | "posts" | "maquette" | "text"
}

const GeneralPosts: React.FC<Props> = ({ post_type }) => {
  const postsRef = useRef<HTMLDivElement>();
  const params = useParams();
  // const [currentPage, setCurrentPage] = useState(1);
  const query = new URLSearchParams(window.location.search);
  const [sort, setSort] = useState<string>(query.get('sort') || 'newest');
  const [pageInfo, setPageInfo] = useState<IPostListResult>({
    category: null,
    current_page: 1,
    per_page: 24,
    post_type: post_type,
    result_posts: [],
    title: "آگهی ها",
    total_count: 0,
    total_pages: 0
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setPageInfo({
      category: null,
      current_page: 1,
      per_page: 24,
      post_type: post_type,
      result_posts: [],
      title: "آگهی ها",
      total_count: 0,
      total_pages: 0
    });
  }, [post_type, sort, params.slug, params.tag, params.s]);

  useEffect(() => {
    setCanonical();
    if(!loading)
      return;
    const query = new URLSearchParams(window.location.search);
    PostsService.getPosts(post_type,  params.slug || '', {
      sort: query.get('sort') || 'newest',
      tag: query.get('tag') || null,
      s: query.get('s') || null,
      page: pageInfo.current_page
    }).then((data : IPostListResult) => {
      setPageInfo({ ...data,
        current_page: Number(data.current_page),
        total_count: Number(data.total_count),
        total_pages: Number(data.total_pages),
        result_posts: [...pageInfo.result_posts, ...data.result_posts]
      })
    }).catch((err: any) => {
      setPageInfo({ ...pageInfo, current_page: Math.max(1, pageInfo.current_page - 1)})
      console.error(err);
    }).finally(() => {
      setLoading(false);
    });
  }, [sort, params.slug, pageInfo.current_page, post_type, loading, params.tag, params.s]);


  useEffect(() => {
    const getNewPosts = () => {
      const postEl = postsRef.current;
      if(postEl && window.scrollY + window.innerHeight > (postEl?.offsetHeight || 0)) {
        if(pageInfo.current_page < pageInfo.total_pages && !loading) {
          setPageInfo({...pageInfo, current_page: Math.min(pageInfo.current_page + 1, pageInfo.total_pages)});
          setLoading(true);
          window.removeEventListener('scroll', getNewPosts);
        }
      }
    };
    if(!loading) window.addEventListener('scroll', getNewPosts);

    return () => window.removeEventListener('scroll', getNewPosts);
  }, [pageInfo, loading]);

  const onSortChange = (s: string) => {
    setSort(s);
  }

  return (
    <Posts postsRef={postsRef} loading={loading} {...pageInfo} onSortChange={onSortChange} sort={sort} />
  );
}

export default GeneralPosts;
